import { createApp } from 'vue';
import i18n from '@scripts/i18n.js';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import {
    CollapsibleContent,
    CollapsibleRoot,
    CollapsibleTrigger,
    NavigationMenuContent,
    NavigationMenuIndicator,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuRoot,
    NavigationMenuTrigger,
    NavigationMenuViewport,
    PopoverAnchor,
    PopoverClose,
    PopoverContent,
    PopoverPortal,
    PopoverRoot,
    PopoverTrigger,
} from 'reka-ui';
import { initCopyToClipboard, initWebShare } from '@scripts/lib/utils';

import '@styles/app.css';

const modules: Record<string, any> = import.meta.glob('@components/**/*.vue', {
    eager: true,
});

const app = createApp({
    components: {
        CollapsibleContent,
        CollapsibleRoot,
        CollapsibleTrigger,
        NavigationMenuContent,
        NavigationMenuIndicator,
        NavigationMenuItem,
        NavigationMenuLink,
        NavigationMenuList,
        NavigationMenuRoot,
        NavigationMenuTrigger,
        NavigationMenuViewport,
        PopoverAnchor,
        PopoverClose,
        PopoverContent,
        PopoverPortal,
        PopoverRoot,
        PopoverTrigger
    },
});

Object.entries(modules).forEach(([path, definition]) => {
    // @ts-ignore
    const componentName = path
        .split('/')
        .pop()
        .replace(/\.\w+$/, '');

    app.component(componentName, definition.default);
});

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(i18n);

app.mount('#app');

initCopyToClipboard();
initWebShare();
